export default "__VITE_ASSET__CqBaO43d__"